import { JSX, useState, useCallback } from 'react';
import classNames from 'classnames';
import { Timer } from '@bg-components/Timer';
import { PlayIcon } from '@bg-components/Icon';
import { timersRegistry } from '@betgames/bg-tools';
import { useStore } from '@betgames/bg-state-manager';
import { ClassicGameDefinition, GameId, gamesStatusEntity, gamesStatusSelectors } from '@bg-shared';
import classes from './GameNavigationTimer.module.scss';

interface IProps {
    gameId: GameId;
    dataQA?: string;
    className?: string;
    timerClassName?: string;
    showLiveIndicator?: boolean;
}

export const GameNavigationTimer = ({
    showLiveIndicator = true,
    ...props
}: IProps): JSX.Element => {
    const isMaintenance = useStore(
        gamesStatusEntity.store(props.gameId),
        gamesStatusSelectors.isMaintenance,
    );
    const timerInstance = timersRegistry.get(props.gameId);
    const [ongoing, setOngoing] = useState<boolean>(timerInstance?.finished);

    const liveIndicator =
        showLiveIndicator &&
        (ongoing || (ClassicGameDefinition.isLive(props.gameId) && !isMaintenance));

    const onTimerFinish = useCallback(() => {
        setOngoing(true);
    }, []);

    const onUpdate = useCallback(() => {
        setOngoing(false);
    }, []);

    if (!timerInstance) {
        return null;
    }

    return (
        <div data-qa={props.dataQA} className={classNames(classes.container, props.className)}>
            {liveIndicator && (
                <div className={classes.liveIndicator} data-qa="area-live-indicator" />
            )}
            {ongoing && <PlayIcon className={classes.playIcon} />}
            <div className={classNames({ [classes.hidden]: ongoing })}>
                <Timer
                    id={props.gameId}
                    onFinish={onTimerFinish}
                    onUpdate={onUpdate}
                    textOnFinish="00:00"
                    blinkOn={1}
                    className={props.timerClassName}
                />
            </div>
        </div>
    );
};
